export const specializationsI18n = {
  "anestezjologia-i-intensywna-terapia": "Anestezjologia i intensywna terapia",
  "audiologia-i-foniatria": "Audiologia i foniatria",
  "chirurgia-dziecieca": "Chirurgia dziecięca",
  "chirurgia-klatki-piersiowej": "Chirurgia klatki piersiowej",
  "chirurgia-ogolna": "Chirurgia ogólna",
  "chirurgia-plastyczna": "Chirurgia plastyczna",
  "chirurgia-szczekowo-twarzowa": "Chirurgia szczękowo-twarzowa",
  "choroby-wewnetrzne": "Choroby wewnętrzne",
  "choroby-zakazne": "Choroby zakaźne",
  "dermatologia-i-wenerologia": "Dermatologia i wenerologia",
  "diagnostyka-laboratoryjna": "Diagnostyka laboratoryjna",
  epidemiologia: "Epidemiologia",
  "genetyka-kliniczna": "Genetyka kliniczna",
  kardiochirurgia: "Kardiochirurgia",
  kardiologia: "Kardiologia",
  "medycyna-nuklearna": "Medycyna nuklearna",
  "medycyna-pracy": "Medycyna pracy",
  "medycyna-ratunkowa": "Medycyna ratunkowa",
  "medycyna-rodzinna": "Medycyna rodzinna",
  "medycyna-sadowa": "Medycyna sądowa",
  "medycyna-transportu": "Medycyna transportu",
  "mikrobiologia-lekarska": "Mikrobiologia lekarska",
  neonatologia: "Neonatologia",
  neurochirurgia: "Neurochirurgia",
  neurologia: "Neurologia",
  okulistyka: "Okulistyka",
  "onkologia-kliniczna": "Onkologia kliniczna",
  "ortopedia-i-traumatologia-narzadu-ruchu":
    "Ortopedia i traumatologia narządu ruchu",
  otorynolaryngologia: "Otorynolaryngologia",
  patomorfologia: "Patomorfologia",
  pediatria: "Pediatria",
  "poloznictwo-i-ginekologia": "Położnictwo i ginekologia",
  psychiatria: "Psychiatria",
  "psychiatria-dzieci-i-mlodziezy": "Psychiatria dzieci i młodzieży",
  "radiologia-i-diagnostyka-obrazowa": "Radiologia i diagnostyka obrazowa",
  "radioterapia-onkologiczna": "Radioterapia onkologiczna",
  "rehabilitacja-medyczna": "Rehabilitacja medyczna",
  "transfuzjologia-kliniczna": "Transfuzjologia kliniczna",
  urologia: "Urologia",
  "zdrowie-publiczne": "Zdrowie Publiczne",
  endokrynologia: "Endokrynologia",
  alergologia: "Alergologia",
  angiologia: "Angiologia",
  "balneologia-i-medycyna-fizykalna": "Balneologia i medycyna fizykalna",
  "chirurgia-naczyniowa": "Chirurgia naczyniowa",
  "chirurgia-onkologiczna": "Chirurgia onkologiczna",
  "choroby-pluc": "Choroby płuc",
  "choroby-pluc-dzieci": "Choroby płuc dzieci",
  diabetologia: "Diabetologia",
  "endokrynologia-ginekologiczna-i-rozrodczosc":
    "Endokrynologia ginekologiczna i rozrodczość",
  "endokrynologia-i-diabetologia-dziecieca":
    "Endokrynologia i diabetologia dziecięca",
  "farmakologia-kliniczna": "Farmakologia kliniczna",
  "fizjologia-kliniczna": "Fizjologia kliniczna",
  gastroenterologia: "Gastroenterologia",
  "gastroenterologia-dziecieca": "Gastroenterologia dziecięca",
  geriatria: "Geriatria",
  "ginekologia-onkologiczna": "Ginekologia onkologiczna",
  hematologia: "Hematologia",
  hipertensjologia: "Hipertensjologia",
  "higiena-i-epidemiologia-wojskowa": "Higiena i epidemiologia wojskowa",
  "immunologia-kliniczna": "Immunologia kliniczna",
  "intensywna-terapia": "Intensywna terapia",
  "kardiologia-dziecieca": "Kardiologia dziecięca",
  "medycyna-lotnicza": "Medycyna lotnicza",
  "medycyna-lotnicza-wojskowa": "Medycyna lotnicza wojskowa",
  "medycyna-morska-wojskowa": "Medycyna morska wojskowa",
  "medycyna-paliatywna": "Medycyna paliatywna",
  "medycyna-sportowa-cywilna": "Medycyna sportowa (cywilna)",
  "medycyna-sportowa-wojskowa": "Medycyna sportowa wojskowa",
  "medycyna-tropikalna": "Medycyna tropikalna",
  "medycyny-morska-i-tropikalna": "Medycyny morska i tropikalna",
  nefrologia: "Nefrologia",
  "nefrologia-dziecieca": "Nefrologia dziecięca",
  "neurologia-dziecieca": "Neurologia dziecięca",
  neuropatologia: "Neuropatologia",
  "ochrona-radiologiczna-wojskowa": "Ochrona radiologiczna wojskowa",
  "onkologia-i-hematologia-dziecieca": "Onkologia i hematologia dziecięca",
  "otorynolaryngologia-dziecieca": "Otorynolaryngologia dziecięca",
  "pediatria-metaboliczna": "Pediatria metaboliczna",
  perinatologia: "Perinatologia",
  reumatologia: "Reumatologia",
  seksuologia: "Seksuologia",
  "toksykologia-kliniczna": "Toksykologia kliniczna",
  "toksykologia-wojskowa": "Toksykologia wojskowa",
  "transplantologia-kliniczna": "Transplantologia kliniczna",
  "urologia-dziecieca": "Urologia dziecięca",
  "zdrowie-publiczne-wojskowe": "Zdrowie publiczne wojskowe",
  "chirurgia-stomatologiczna": "Chirurgia stomatologiczna",
  ortodoncja: "Ortodoncja",
  periodontologia: "Periodontologia",
  "protetyka-stomatologiczna": "Protetyka stomatologiczna",
  "stomatologia-dziecieca": "Stomatologia dziecięca",
  "stomatologia-zachowawcza-z-endodoncja":
    "Stomatologia zachowawcza z endodoncją",
  higiena: "Higiena",
  "pedagogika-medyczna": "Pedagogika medyczna",
};
